import type { Asset } from '@/types';

function useTokenContractAddress(token: Asset) {
  return token.assetId;
}

export default useTokenContractAddress;
